export default __webpack_public_path__ + "static/media/logo_t.b1ae19c3.png";